<template>
  <pages-home-block
    :block="block"
  />
</template>

<script>
// Modules
import PagesHomeBlock from 'pages/home/Block';

// Images
const images = {
  ourMission: require(`images/home/our-mission.svg`),
  tick: require(`images/icons/tick.svg`),
};

export default {
  name: `ui-our-mission`,

  // Compononts
  components: {
    PagesHomeBlock,
  },

  // Data
  data () {
    return {
      block: {
        slug: `why`,
        block: `lightest`,
        image: {
          image: images.ourMission,
          alt: `Our Mission`,
        },
        content: {
          heading: `Our Mission`,
          subheading: `Help us highlight quality in the dental industry`,
          copy: [
            `How can you find a good quality dentist and trust the work he/she does? Online reviews cover things like cost, timeliness and the office environment. At VeriTooth we go deeper to actually assess the quality of the dental work itself.`,
            `Dentists spend over 8 years learning their profession. And dentistry is a science with clear guidelines for what is and isn’t quality care. These guidelines were defined by the AAE (American Association of Endodontists), the ADA (American Dental Association) recognized experts in root canal. We've input those criteria into the platform and use them to help validate the quality of work provided.`,
            `Now both patients and dentists can have a transparent conversation about quality dental care.`,
          ],
        },
      },
    };
  },
};
</script>



// WEBPACK FOOTER //
// OurMission.vue?e6071a06